import { ProjectContactForm } from './ProjectContactForm';
import { Phone, MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { ReportButton } from '@/components/ReportButton';

interface ProjectContactSidebarProps {
  projectId: string;
  referenceCode?: string;
  phone?: string;
  whatsapp?: string;
}

export function ProjectContactSidebar({ projectId, referenceCode, phone = '+251', whatsapp = '251' }: ProjectContactSidebarProps) {
  const cleanWa = (whatsapp || '').replace(/\D/g, '');
  return (
    <div className="hidden lg:block sticky top-24 space-y-4">
      <div className="border rounded-xl overflow-hidden">
        <div className="flex">
          <Button className="flex-1 rounded-none h-12 text-sm font-bold gap-2" asChild>
            <a href={`tel:${phone}`}>
              <Phone className="h-4 w-4" /> Call Now
            </a>
          </Button>
          <Button variant="outline" className="rounded-none h-12 w-14 border-l-0" asChild>
            <a href={`https://wa.me/${cleanWa}`} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
              <MessageCircle className="h-5 w-5 text-[hsl(142,70%,45%)]" />
            </a>
          </Button>
        </div>

        <div className="p-5">
          <div className="flex items-center gap-3 mb-4">
            <Separator className="flex-1" />
            <span className="text-xs text-muted-foreground">or</span>
            <Separator className="flex-1" />
          </div>

          <ProjectContactForm projectId={projectId} referenceCode={referenceCode} />
        </div>
      </div>

      <div className="border rounded-xl p-3 bg-muted/40">
        <ReportButton
          targetType="project"
          targetId={projectId}
          variant="outline"
          className="w-full border-destructive/30 text-destructive hover:bg-destructive hover:text-destructive-foreground font-semibold text-sm"
          label="Report this project"
        />
      </div>
    </div>
  );
}
